export default {
  "nav.thesis": "Tesi",
  "nav.disciplines": "Discipline",
  "nav.horizon": "Orizzonte",
  "nav.join": "Candidati",
  "nav.backus": "Iscriviti",
  "nav.invest": "Sostienici",

  "hero.badge": "Ingegneria della Longevità",
  "hero.l1": "L'immortalità umana è teorica.",
  "hero.l2": "150 anni sono pratici.",
  "hero.sub": "La longevità è una sfida umana multidisciplinare. La Medicina e le Scienze della Salute hanno guidato progressi straordinari nella longevità. Le prossime scoperte potrebbero nascere dalla loro convergenza con l'ingegneria, l'IA, la neurologia, la psicologia, la scienza cognitiva, la meccanica quantistica, la fisica delle particelle e lo spazio-tempo.",
  "hero.sub2": "The Lifespan Project riunisce queste discipline. Nulla nelle leggi note della fisica sembra vietare una vita umana molto più lunga. Intendiamo indagare e dimostrare ciò che è possibile.",
  "hero.cta1": "Iscriviti al Progetto",
  "hero.cta2": "Leggi la Tesi",
  "hero.stats1": "09 Discipline",
  "hero.stats2": "Scala Subliminale",
  "hero.stats3": "Prime Soluzioni ≤ 24 Mesi",
  "hero.caption": "Ricerca su scala subliminale in corso",

  "mq.1": "Spazio-Tempo",
  "mq.2": "Fisica delle Particelle",
  "mq.3": "Meccanica Quantistica",
  "mq.4": "Computazione IA",
  "mq.5": "Biologia",
  "mq.6": "Neurologia",
  "mq.7": "Psicologia",
  "mq.8": "Scienze Cognitive",
  "mq.11": "Scienze della Salute",
  "mq.12": "Scienza Medica",
  "mq.9": "Longevità",
  "mq.10": "150+ Anni",

  "mani.eyebrow": "Il Manifesto",
  "mani.h2a": "La morte è il più antico",
  "mani.h2b": "problema irrisolto",
  "mani.h2c": "della fisica.",
  "mani.c1t": "La Tesi",
  "mani.c1b": "L'invecchiamento non è una legge della natura; è un problema di ingegneria non risolto. Crediamo fermamente che l'essere umano possa raggiungere l'immortalità in teoria, e una vita oltre i 150 anni in pratica, in un futuro prossimo. Ogni disciplina che tocchiamo punta nella stessa direzione.",
  "mani.c2t": "Il Metodo",
  "mani.c2b": "I nostri programmi di ricerca e computazione operano su scala subliminale: sotto il rumore, attraverso l'intera materia e la mente. Dalle interazioni delle particelle alla computazione neurale, modelliamo la vita come un sistema che può essere compreso, simulato ed esteso.",
  "mani.c3t": "L'Orizzonte",
  "mani.c3b": "Non è un'impresa da un secolo. Entro i prossimi due anni lanceremo le nostre prime soluzioni; i primi artefatti di un programma molto più grande. Ciò che segue si moltiplica.",
  "mani.c4t": "Il Modello",
  "mani.c4b": "La nostra ricerca è sostenuta da un ampio ecosistema: sostenitori, investitori, abbonati accademici, filantropi, grandi patrimoni, imprenditori, aziende partner e sponsor aziendali. Prodotti e servizi fluiscono attraverso The Lifespan Labs per mantenere la ricerca in movimento; sono il motore, mai lo scopo.",

  "disc.eyebrow": "Lo Stack",
  "disc.h2a": "Nove discipline.",
  "disc.more": "Come converge",
  "disc.converge": "Medicina × Fisica × Longevità",
  "disc.h2b": "Una variabile.",
  "disc.sub": "La longevità non è solo un problema di biologia. È un problema a sistema completo, dalle particelle alla coscienza.",
  "disc.d1n": "Spazio-Tempo e Materia",
  "disc.d1d": "La vita si svolge dentro un tessuto fisico. Studiamo come la materia si organizza, persiste e si ripara nel tempo.",
  "disc.d1x": "La medicina misura l'invecchiamento in anni; la fisica chiede cosa sia il tempo stesso. Studiando come la materia si organizza e persiste nello spazio-tempo, cerchiamo le leve più profonde che permettono ai sistemi viventi di resistere al decadimento.",
  "disc.d2n": "Fisica delle Particelle",
  "disc.d2d": "Alle scale più piccole si trovano le regole che tutto il resto obbedisce.",
  "disc.d2x": "Ogni farmaco, cellula e pensiero è costruito da particelle che obbediscono a regole precise. Comprendere quelle regole alle scale più piccole permette alla medicina di progettare interventi con accuratezza atomica invece di approssimazioni.",
  "disc.d3n": "Meccanica Quantistica",
  "disc.d3d": "Coerenza, decoerenza e la base quantistica della macchina biologica.",
  "disc.d3x": "La vita funziona già con macchinari quantistici: enzimi, fotosintesi e forse la cognizione. Dove la medicina incontra la fisica quantistica, esploriamo coerenza, tunneling e rilevamento come nuovi strumenti per leggere e riparare la biologia.",
  "disc.d4n": "IA e Computazione",
  "disc.d4d": "Simulazione e intelligenza artificiale comprimono decenni di prove biologiche in giorni di calcolo.",
  "disc.d4x": "L'IA comprime decenni di tentativi medici in giorni di simulazione. Abbinata a modelli fisici del corpo, ci permette di testare molecole e terapie in silico prima che raggiungano un paziente.",
  "disc.d5n": "Biologia",
  "disc.d5d": "Riparazione cellulare, senescenza e rigenerazione: le leve dirette della longevità.",
  "disc.d5x": "La biologia dà alla medicina i suoi obiettivi: riparazione cellulare, senescenza e rigenerazione. Combinata con misurazioni di precisione fisica, l'invecchiamento passa da mistero a specifica ingegneristica.",
  "disc.d6n": "Neurologia",
  "disc.d6d": "Il cervello è il nucleo insostituibile. Proteggerlo ed estenderlo non è negoziabile.",
  "disc.d6x": "Il cervello è dove la medicina non può ancora sostituire ciò che si guasta. La neurologia converge con fisica e informatica per proteggere, interfacciare e un giorno estendere il nucleo insostituibile di ciò che siamo.",
  "disc.d7n": "Psicologia e Scienze Cognitive",
  "disc.d7d": "Una vita più lunga deve restare una vita che vale la pena vivere: mente, memoria e significato inclusi.",
  "disc.d7x": "Una vita più lunga conta solo se la mente prospera. Scienza cognitiva e medicina mappano insieme come memoria, motivazione e significato cambiano con l'età, perché gli anni aggiunti restino degni di essere vissuti.",
  "disc.d8n": "Scienze della Salute",
  "disc.d8d": "Salute pubblica, nutrizione e prevenzione, le leve su scala di popolazione che hanno già aggiunto decenni alla vita umana.",
  "disc.d8x": "La salute pubblica ha aggiunto decenni alla vita umana senza una singola pillola: igiene, nutrizione, prevenzione. Misurate con precisione fisica, queste leve di popolazione diventano infrastrutture programmabili per la longevità.",
  "disc.d9n": "Scienza Medica",
  "disc.d9d": "La medicina clinica trasforma la ricerca sulla longevità in pratica: diagnostica, terapie e cure che estendono gli anni in salute.",
  "disc.d9x": "La medicina trasforma ogni scoperta in pratica. Convergendo con fisica e ingegneria, diagnostica, imaging e terapie guadagnano la risoluzione per intercettare precocemente l'invecchiamento e invertirlo con precisione.",

  "time.eyebrow": "L'Orizzonte",
  "time.h2a": "Due anni alle",
  "time.h2b": "prime soluzioni.",
  "time.m1t": "Ora",
  "time.m1h": "Ricerca su Scala Subliminale",
  "time.m1b": "Programmi profondi di ricerca e computazione su larga scala sono già in corso, in silenzio, sotto il radar, tra fisica, IA e biologia.",
  "time.m2t": "T + 12 Mesi",
  "time.m2h": "Prime Intervenzioni Candidate",
  "time.m2b": "I primi risultati validati del programma passano dalla simulazione alla valutazione strutturata.",
  "time.m3t": "T + 24 Mesi",
  "time.m3h": "Arrivo delle Prime Soluzioni",
  "time.m3b": "Le nostre prime soluzioni vengono lanciate. L'inizio di una catena cumulativa verso l'estensione radicale della vita.",
  "time.outro": "Resta sintonizzato. L'orologio è già in movimento.",

  "pipe.eyebrow": "La Pipeline",
  "pipe.h2a": "Dalla ricerca fondamentale alle",
  "pipe.h2b": "soluzioni del mondo reale.",
  "pipe.s1t": "Ricerca Fondamentale",
  "pipe.s1tail": "e discipline correlate.",
  "pipe.s2t": "Modelli e Scoperta",
  "pipe.s3t": "Tecnologia",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "Un ecosistema curato di prodotti e servizi a sostegno di una vita più sana, più lunga e migliore.",
  "pipe.s5t": "L'Ecosistema della Vita Più Lunga",
  "pipe.s5tail": "e soluzioni orientate alla longevità.",

  "back.eyebrow": "Il Programma",
  "back.h2a": "Prima, l'",
  "back.h2b": "equazione dell'immortalità.",
  "back.h2c": "Poi, tutto ciò che sblocca.",
  "back.badge": "Prima la prova, poi il prodotto",
  "back.copy": "Il nostro lavoro centrale è matematico: una dimostrazione basata sulla fisica, l'equazione dell'immortalità, che formalizza perché il tempo biologico può essere arrestato e invertito. Ogni soluzione che costruiamo deriva da essa.",
  "back.cta1": "Iscriviti al Progetto",
  "back.cta2": "Sostienici",

  "sub.eyebrow": "Resta Vicino alla Ricerca",
  "sub.h2a": "Iscriviti agli aggiornamenti.",
  "sub.h2b": "Entra nella comunità.",
  "sub.p": "Notizie di ricerca, pubblicazioni e aggiornamenti dell'ecosistema, direttamente nella tua casella. Ogni nuovo iscritto riceve una Tessera Digitale di Membresia come Prime Member, con il primo mese gratuito.",
  "sub.success.h": "Benvenuto nella comunità.",
  "sub.success.p": "La tua Tessera Digitale di Membresia come Prime Member è qui sotto, e una copia è in arrivo nella tua casella, con il primo mese gratuito.",
  "sub.download": "Scarica la Tessera di Membresia",
  "sub.submit": "Iscriviti agli Aggiornamenti",
  "sub.sending": "Iscrizione in corso...",

  "form.name": "Nome completo",
  "form.email": "Email",
  "form.phone": "Numero di contatto",
  "form.country": "Paese",
  "form.city": "Città",
  "form.ph.name": "Il tuo nome",
  "form.ph.country": "India",
  "form.ph.city": "Mumbai",
  "form.error": "Qualcosa è andato storto. Riprova o scrivi a invest@thelifespanproject.com.",
  "form.sending": "Invio in corso...",

  "footer.desc": "Un'iniziativa multidisciplinare di ricerca sulla longevità umana, che progetta i prossimi 150 anni di vita umana.",
  "footer.explore": "Esplora",
  "footer.contact": "Contatti",
  "footer.legal": "Legale",
  "footer.terms": "Termini",
  "footer.privacy": "Informativa Privacy",
  "footer.refund": "Politica di Rimborso",
  "footer.faq": "Domande Frequenti",
  "footer.partners": "Partner Tecnologici e Sostenitori",
  "footer.copyright": "© 2026 The Lifespan Project. Tutti i diritti riservati.",
  "footer.tagline": "L'immortalità è teorica. 150 anni sono pratici.",

  "pick.title": "Scegli la tua vista",
  "pick.sub": "Scegli un tema per iniziare. Puoi cambiarlo in qualsiasi momento dall'intestazione.",
  "pick.dark": "Scuro",
  "pick.dark.sub": "Cinematografico",
  "pick.light": "Chiaro",
  "pick.light.sub": "Bianco sfumato",

  "cookie.text": "Questo sito utilizza cookie essenziali e analisi rispettose della privacy. Continuando, accetti la nostra",
  "cookie.accept": "Ho capito",

  "inv.badge": "Relazioni con gli Investitori",
  "inv.h1a": "Investi nei",
  "inv.h1b": "prossimi 150 anni.",
  "inv.sub": "The Lifespan Project è un'iniziativa multidisciplinare di ricerca sulla longevità umana. Dicci chi sei e il nostro team ti contatterà con il dossier completo per investitori.",
  "inv.perks.h": "Cosa ricevono gli investitori",
  "inv.perk1": "Dossier completo per investitori e roadmap della ricerca",
  "inv.perk2": "Linea diretta con il team fondatore",
  "inv.perk3": "Data room e documentazione tecnica su richiesta",
  "inv.perk4": "Visibilità anticipata sulla pipeline delle soluzioni",
  "inv.next.h": "Cosa succede dopo",
  "inv.next.p": "Ricevi subito una conferenza brandizzata con copia della tua richiesta. Il nostro team ti contatta poi personalmente con il dossier per investitori. Preferisci l'email? Scrivi a",
  "inv.org": "Organizzazione",
  "inv.ph.org": "Fondo, istituzione o azienda",
  "inv.interest": "Il tuo interesse",
  "inv.ph.interest": "Dimensione del ticket, mandato, tempistiche...",
  "inv.submit": "Richiedi il Dossier per Investitori",
  "inv.success.h": "Grazie, richiesta ricevuta.",
  "inv.success.p": "Una conferma brandizzata con copia della tua richiesta è in arrivo nella tua casella. Il nostro team ti contatterà a breve.",

  "join.badge": "Collabora con Noi",
  "join.h1a": "Entra nel laboratorio come",
  "join.h1b": "collaboratore.",
  "join.sub": "Lavoriamo con ricercatori, clinici e professionisti eccezionali come stagisti e collaboratori, sull'equazione dell'immortalità e su tutto ciò che sblocca.",
  "join.elig.h": "Requisiti minimi",
  "join.elig1": "Dottorato, PhD, MBBS o MD",
  "join.elig2": "O doppia specializzazione post-laurea in qualsiasi ambito",
  "join.elig3": "Attualmente professionista attivo, ovunque",
  "join.elig4": "Almeno 5 anni di esperienza, in India o all'estero",
  "join.next.h": "Cosa succede dopo",
  "join.next.p": "Ogni candidatura è esaminata personalmente dal nostro team di ricerca. Ricevi subito una copia via email del tuo invio, e ti contattiamo se c'è affinità.",
  "join.qual": "Titolo di studio più alto",
  "join.qual.select": "Seleziona il titolo",
  "join.disc": "Quale disciplina ti rappresenta di più?",
  "join.disc.select": "Seleziona una disciplina",
  "join.disc.unsure": "Non ancora sicuro",
  "join.spec": "Specializzazione / ambito",
  "join.ph.spec": "es. Biologia quantistica, neurologia",
  "join.exp": "Anni di esperienza",
  "join.ph.exp": "Min. 5",
  "join.role": "Ruolo attuale e organizzazione",
  "join.ph.role": "es. Ricercatore scientifico, CSIR",
  "join.why": "Perché vuoi collaborare?",
  "join.ph.why": "I tuoi interessi di ricerca, pubblicazioni, su cosa lavoreresti...",
  "join.ph.country": "India / estero",
  "join.submit": "Candidati come Collaboratore",
  "join.submitting": "Invio in corso...",
  "join.success.h": "Candidatura ricevuta.",
  "join.success.p": "Una copia del tuo invio è in arrivo nella tua casella. Il nostro team di ricerca esamina personalmente ogni candidatura.",

  "bu.badge": "Facciamo avanzare la scienza della longevità umana",
  "bu.h1a": "Diventa",
  "bu.h1b": "Membro Fondatore",
  "bu.h1c": "di The Lifespan Project.",
  "bu.sub": "Il futuro della longevità umana non sarà costruito da una sola disciplina, un solo laboratorio o una sola tecnologia. Sarà costruito attraverso ricerca, sperimentazione, collaborazione e la traduzione della conoscenza scientifica in soluzioni tangibili. La tua membresia aiuta a sostenere questo percorso.",
  "bu.projline": ": la ricerca della scienza.",
  "bu.labsline": ": dare vita alle soluzioni per la longevità.",

  "arch.eyebrow": "La Struttura",
  "arch.h2a": "Una missione.",
  "arch.h2b": "Due motori.",
  "arch.proj.h": "R&S Scientifica",
  "arch.labs.h": "Marketplace della Longevità",

  "flow.1": "Ricerca",
  "flow.2": "Validazione",
  "flow.3": "Tecnologia",
  "flow.4": "Prodotti e Servizi",
  "flow.5": "Vita Più Lunga e Sana",

  "pos.eyebrow": "Cosa Significa Essere Membro",
  "pos.h2": "Non ti stai semplicemente abbonando a dei contenuti.",
  "pos.p": "Stai diventando parte della comunità fondatrice dietro la ricerca. La membresia sostiene lo sviluppo continuo di ricerca, lavoro scientifico, conoscenza, sperimentazione e la futura pipeline di soluzioni di The Lifespan Project. In cambio, i Membri Fondatori ricevono una Membresia Digitale di Fondatore che li connette al crescente ecosistema Lifespan.",
  "pos.note": "La membresia non garantisce alcun risultato scientifico, esito di salute o aumento della longevità.",

  "eco.eyebrow": "Membresia Digitale di Fondatore",
  "eco.h2a": "La tua membresia si estende",
  "eco.h2b": "oltre la ricerca.",
  "eco.sub": "Ogni Membro Fondatore riceve una Membresia Digitale al crescente ecosistema Lifespan, incluso l'accesso al prossimo marketplace The Lifespan Labs.",
  "eco.c1n": "Salute",
  "eco.c2n": "Alimentazione e Nutrizione",
  "eco.c3n": "Biomarcatori e Laboratori",
  "eco.c4n": "Medici e Servizi Sanitari",
  "eco.c5n": "Dispositivi e Macchine",
  "eco.c6n": "Sport e Corpo",
  "eco.c7n": "Guarigione e Fisioterapia",
  "eco.c8n": "Mente e Psicologia",
  "eco.c9n": "Mente · Corpo · Anima",

  "ben.eyebrow": "Vantaggi del Membro Fondatore",
  "ben.h": "Cosa ricevono i Membri Fondatori",

  "mode.free": "Gratis",
  "mode.monthly": "Mensile",
  "mode.life": "A vita",
  "cad.month": "al mese",
  "cad.life": "a vita",
  "cad.free": "per sempre",
  "cad.month.short": "mese",
  "reg.intl": "Fuori dall'India",
  "reg.in": "India",

  "plan.prime.tag": "La porta d'ingresso all'ecosistema Lifespan.",
  "plan.prime.f1": "Tessera Digitale di Membresia di Fondatore con codice scansionabile",
  "plan.prime.f2": "Tutta la ricerca, i contenuti e i video pubblicati",
  "plan.prime.f3": "Accesso a The Lifespan Labs al lancio",
  "plan.prime.f4": "Offerte per i membri e prezzi preferenziali",
  "plan.prime.f5": "Invia ricerche per la valutazione tra pari",
  "plan.pro.tag": "Tutto ciò che offre Prime, a vita. Più la cerchia ristretta.",
  "plan.pro.f1": "Membresia a vita, senza rinnovi",
  "plan.pro.f2": "Rilasci di ricerca ed esclusive solo Pro",
  "plan.pro.f3": "Inviti a incontri ed eventi di ricerca in tutto il mondo",
  "plan.pro.f4": "Sconti maggiorati su The Lifespan Labs",
  "plan.pro.f5": "Accesso prioritario a nuovi prodotti e servizi",
  "plan.well.tag": "Resta vicino alla scienza, a costo zero.",
  "plan.well.f1": "Tessera Digitale di Membresia Wellwisher con codice",
  "plan.well.f2": "Notizie e aggiornamenti sulla ricerca",
  "plan.well.f3": "Primo a sapere del lancio di The Lifespan Labs",

  "cta.subscribe": "Iscriviti Qui",
  "cta.free": "Iscriviti Gratis",
  "cta.welllink": "Iscriviti Gratis come Wellwisher",

  "why.eyebrow": "Il Perché",
  "why.h": "Perché diventare Membro Fondatore?",
  "why.1t": "Sostieni la Ricerca",
  "why.2t": "Accedi all'Ecosistema",
  "why.3t": "Scopri Cosa Arriva",
  "why.4t": "Aiuta a Plasmare il Futuro",

  "flowS.eyebrow": "Come si Collega",
  "flowS.h": "Dalla ricerca alla comunità",
  "flowS.n1t": "R&S · Scienza · Ricerca · Tecnologia",
  "flowS.n2t": "Prodotti · Servizi · Marketplace · Accesso",
  "flowS.n3t": "Comunità · Accesso · Partecipazione",
  "flowS.proline": "I Membri Fondatori Pro possono ricevere inviti a incontri di ricerca, conferenze ed eventi dell'ecosistema Lifespan Project in tutto il mondo.",
  "net.caption": "Rete globale di ricerca",

  "ck.eyebrow": "Diventa Membro Fondatore",
  "ck.h": "Attiva la tua membresia",
  "ck.submit": "Procedi al Pagamento Sicuro",
  "ck.sending": "Apertura del pagamento sicuro...",
  "ck.per.month": " / mese",
  "ck.per.life": " a vita",
  "ck.note1": "Registrato come abbonamento",
  "ck.note2": ". Ricevuta e fattura seguono via email.",
  "ck.invite.toggle": "Hai un codice invito?",
  "ck.invite.code": "Codice invito",
  "ck.invite.sending": "Sto applicando il tuo invito...",
  "ck.invite.submit": "Riscatta l'iscrizione gratuita",
  "ck.invite.note": "Un invito valido rende il piano selezionato completamente gratuito.",
  "ck.invite.ph": "Inserisci il tuo codice",
  "ck.inrnote": "Carte internazionali accettate. Razorpay addebita in INR al prezzo in rupie indicato.",
  "ck.orwell": "Non sei ancora pronto a sostenere la ricerca?",

  "close.h2a": "Non limitarti a guardare il",
  "close.h2b": "futuro della longevità.",
  "close.h2c": "Aiuta a costruirlo.",
  "close.p": "The Lifespan Project sta costruendo la ricerca. The Lifespan Labs riunirà l'ecosistema. I Membri Fondatori aiutano a rendere possibile questo percorso e diventano parte di ciò che verrà.",
  "close.prime": "Diventa Membro Prime",
  "close.pro": "Diventa Membro Pro",
  "close.or": "oppure",

  "res.h2a": "Hai un'idea?",
  "res.h2b": "Portala al Progetto.",
  "res.cta": "Invia la tua ricerca",

  "ww.eyebrow": "Gratis per sempre",
  "ww.title": "Diventa Wellwisher Founding Member",
  "ww.sub": "Notizie e aggiornamenti sulla ricerca, e la tua Tessera Digitale di Membresia Wellwisher con codice scansionabile, consegnata all'istante.",
  "ww.success.p": "Benvenuto. La tua tessera è qui sotto, e una copia è in arrivo nella tua casella.",
  "ww.submitting": "Iscrizione in corso...",

  "legal.notice": "Questo documento legale è fornito in inglese per preservarne il significato esatto.",

  "ui.language": "Lingua",
  "ui.theme": "Tema",
};
